<zbp-button-component id="infoButton"
                      [ngbPopover]="popoverControl?.popoverContent"
                      popoverClass="viewer-control-popover"
                      [popperOptions]="popperOptions"
                      (shown)="showPopover()"
                      (hidden)="closePopover()"
                      [autoClose]="'outside'"
                      [placement]="isDesktop ? 'right' : 'top'"
                      container="body"
                      [openDelay]="0"
                      [closeDelay]="0"
                      [theme]="'viewerControl'"
                      [borderRadius]="'0'"
                      [label]="'info'"
                      [ariaLabel]="'info'"
                      [ariaExpanded]="isPopoverOpen"
                      [iconPosition]="'top'"
                      [iconName]="zbpIconNames.info_circle"
                      #popover="ngbPopover"
                      [customClass]="'viewer-asset-control-button'"
>
</zbp-button-component>

<zbp-viewer-control-popover #popoverControl="ControlPopoverComponent"
                            title="INFO"
                            (shouldClosePopover)="popover.close()">
  <div class="info-content"
      [innerHTML]="asset?.additionalInfo || ''">
  </div>
</zbp-viewer-control-popover>

